import { CustomMapPage } from 'pages/custom/shared/CustomMapPage';
import { CompanyButtonsWithProgramme } from 'pages/custom/shared/detail/CompanyButtonsWithProgramme';
import { S_PageStyle } from 'pages/page/PageStyle';
import { Localization } from 'static/localization/localization';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
}

export const TydalsPage = (props: Props): JSX.Element => {
    return (
        <S_TydalsPage className={props.className}>
            <CustomMapPage
                mapId={'1c7f4607-6d6b-4624-b29d-a03d718986dc'}
                highlightedStyle={''}
                header={{
                    logo: 'https://dvtqxks0zalev.cloudfront.net/3564087b-0d2b-4f7e-a069-277a6216e1b7.png',
                    link: 'https://www.tydalsfestivaln.no/',
                    linkText: Localization.WEBSITE,
                    logoMarginTop: '0px',
                    logoText: 'Tydalsfestivalen',
                    logoSubtext: '14-15 July 2023'
                }}
                controls={
                    <CompanyButtonsWithProgramme
                        listTitle="places"
                        hideHighlight={true}
                        hideProgramme={true}
                    />
                }
            />
        </S_TydalsPage>
    );
};

const S_TydalsPage = styled(S_PageStyle)`
    display: flex;
    flex-direction: column;
    position: relative;
`;
